import React from "react";
import {convertTimestampFormat} from "./dateUtils";
import moment from "moment";
import remove from "lodash/remove";
import map from "lodash/map";
import forEach from "lodash/forEach";
import CONST from "../constants/Constants";
import Loading from "../components/Loading";

export const deleteItemFromArray = (array, id) => {
    return remove(array, item => item.id !== id);
}

export const setPageTitle = title => {
    document.title = title;
};

export const isTextOverflow = cellContend => cellContend.offsetHeight < cellContend.scrollHeight || cellContend.offsetWidth < cellContend.scrollWidth;

export const isTextLineBreak = value => /\r|\n/.exec(value);

export const removeTextInBrackets = (str) => {
    return str.split(/\[.*?]/).join('').trim();
}

export const getHealthStatus = (statusCount) => {
    const healthStatuses = {
        0: "In progress",
        1: "Success",
        2: "Failed"
    }

    return healthStatuses[statusCount];
}

export const getSortOrder = order => {
    const sortOrder = {
        'asc': 0,
        'desc': 1,
    };

    return sortOrder[order] || 0;
};

export const renderBigNumbers = (row, column, value) => {
    const stringValue = value.toString().split("").reverse();
    const countArray = [];
    forEach(stringValue, (number, i) => {
        if (i % 3 === 0 && i !== 0) {
            countArray.push(' ');
        }
        countArray.push(number);
    })
    return countArray.reverse().join('');
}

export const convertToArrayOfObjects = (array) => {
    return map(array, item => {
        return {id: item, name: item};
    });
}

export const convertObjectToArrayOfKeys = (object) => map(object, tag => tag.id);

export const updateItemInArray = (target, item) => {
    return map(target, targetItem => {
        return targetItem.id === item.id ? item : targetItem;
    });
};

export const getLastUpdateTitle = (lastUpdate, title) => {
    let lastUpdateTitle = <div>Last update – <Loading/></div>;
    if (lastUpdate && lastUpdate.timestamp) {
        const lastUpdateTime = convertTimestampFormat(lastUpdate.timestamp, CONST.DATE_FORMAT_WITH_TIME);
        lastUpdateTitle = `Last update – ${lastUpdateTime}`
    }

    return lastUpdateTitle;
}

export const convertArrayOfObjectsToFlatArray = (array, key = 'id') => map(array, item => item[key]);

// escape special characters
const escapeRegExp = (str) => {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export const getHighlightSubstring = (str, substr) => {
    const escapedSubstr = escapeRegExp(substr);
    return str.replace(RegExp(escapedSubstr, 'i'), `<span class="highlight-text">${substr}</span>`);
}

export const escapeHTML = (html) => html.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/\*/g,'&#8727;');

export const healthServicesName = {
    "/sales": "Magnet for Sales",
    "/vendors": "Magnet for Vendors",
}

export const checkMagnetCheckpoint = (checkpoint) => {
    const date = convertTimestampFormat(checkpoint, CONST.DATE_STANDARD_FORMAT);
    const checkDate = moment().subtract(3,'d').format(CONST.DATE_STANDARD_FORMAT);
    return moment(checkDate).isAfter(date);
}
